module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "afm1",
      "title": "INTRODUCTION"
    }
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#fm1"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal0"
  }, [_vm._v("Welcome to the "), _c('i', [_vm._v("Focus & Filter")]), _vm._v(" virtual photo studio! I’m Andrew, and I’ll be your guide as we navigate the world of digital photography. This book contains specific suggestions for taking photos, finding the right gear, and using traditional and nontraditional approaches to improving your photography.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("This book is geared primarily toward intermediate to advanced photographers (amateurs and pros) who use cameras that have the ability to manually set the exposure, aperture, ISO and similar functions. Those cameras generally fall into these categories: digital single-lens reflex cameras (DSLRs), mirrorless interchangeable lens cameras (MILCs), digital rangefinder cameras, and advanced, compact fixed-lens cameras. You can use this guide as a reference before going on a trip or on an assignment. That assignment might come from a Fortune 500 company, a local hair salon or your significant other who has been asking you for weeks to create a family portrait. This book was not tailored for those who want to use the “P” or program mode, or “scene modes” on their cameras (usually indicated by cute little icons like flowers and fireworks). While those may be useful in some situations, I’m here to help you truly take control of your equipment and create images worthy of your passion and creativity.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("I’ve been fortunate to make photography my profession since the early ’90s, and witnessed the evolution of digital photography from its infancy. My clients (either through my own company or as the head photographer for another company) have included Brooks Brothers, The Body Shop, Kenneth Cole, Swatch International, Victorinox and many families who have asked me to help them preserve special memories in their lives.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("My editorial work and photo tips have been internationally published in magazines and newspapers, and I’ve written three other books on photography topics. For more than 20 years I’ve been teaching others how to improve, edit and print their photographs, and with this book I’ve decided to pull back the curtain and share many of the secrets I’ve been using to help me get my work done efficiently and at a high-quality level.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('i', [_vm._v("Focus & Filter")]), _vm._v(" is broken down into 50 how-tos, with four main sections: Master Your DSLR, Shopping Smart, Studio Mastery and Shooting in the Field. There’s no need to follow all of the tips in order, but the first 19 tips are designed to be read in order. You’ll also find some overlap, such as "), _c('span', {
    attrs: {
      "href": "#/text/Chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tip 7")]), _vm._v(" (page 31), which covers how to carry equipment much easier; it also includes techniques and products that I use and/or recommend. After each tip, I invite you to delve deeper by giving you a “Pro Assignment” to help you expand upon what you’ve just learned. For more resources visit "), _c('a', {
    attrs: {
      "href": "http://www.focusandfilter.com",
      "target": "_blank"
    }
  }, [_vm._v("www.focusandfilter.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("And with that, I look forward to spending some quality time with you behind the camera!")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("All the best,")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Andrew")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e009d4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Introduction.vue
// module id = 72
// module chunks = 0